<template>
  <span>
    <span v-for="(elem, n) in Array(noteMax)" :key="n">
      <font-awesome-icon v-if="getState(n) === -1" icon="star" />
      <font-awesome-icon v-else-if="getState(n) === 0" icon="star-half-alt" />
      <font-awesome-icon v-else :icon="['far', 'star']" />
  </span>
  </span>
</template>

<script>
export default {
  name: 'stars',
  props: {
    noteMax: {
      type: Number,
      default: 0,
    },
    note: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    roundedNote() {
      return Math.round(this.note * 2) / 2;
    },
  },
  methods: {
    getState(n) {
      if ((n + 1) <= this.roundedNote) {
        return -1;
      }
      if (this.roundedNote > n && this.roundedNote < n + 1) {
        return 0;
      }
      return 1;
    },
  },
};
</script>
